/**
 * Translation module aggregator
 * Exports all translation modules
 */

import { commonTranslations } from './common';
import { authTranslations } from './auth';
import { headerTranslations } from './header';
import { adminTranslations } from './admin';
import { dashboardTranslations } from './dashboard';
import { cvAnalyzerTranslations } from './cvAnalyzer';
import { jobAnalyzerTranslations } from './jobAnalyzer';
import { fileUploadComponentTranslations } from './fileUploadComponent';
import { companyResearchTranslations } from './companyResearch';
import { versionHistoryTranslations } from './versionHistory';
import { profileTranslations } from './profile';
import { userProfileTranslations } from './userProfile';
import { teamManagementTranslations } from './teamManagement';
import { userManagementTranslations } from './userManagement';
import { errorsTranslations } from './errors';
import { errorMessagesTranslations } from './errorMessages';
import { trainingTranslations } from './training';
import { resultTranslations } from './result';
import { validationTranslations } from './validation';
import { reportsTranslations } from './reports';

// Export individual modules
export {
  commonTranslations,
  authTranslations,
  headerTranslations,
  adminTranslations,
  dashboardTranslations,
  cvAnalyzerTranslations,
  jobAnalyzerTranslations,
  fileUploadComponentTranslations,
  companyResearchTranslations,
  versionHistoryTranslations,
  profileTranslations,
  userProfileTranslations,
  teamManagementTranslations,
  userManagementTranslations,
  errorsTranslations,
  errorMessagesTranslations,
  trainingTranslations,
  resultTranslations,
  validationTranslations,
  reportsTranslations
};

// Aggregate all translations into a single object
export const allTranslations = {
  common: commonTranslations,
  auth: authTranslations,
  header: headerTranslations,
  admin: adminTranslations,
  dashboard: dashboardTranslations,
  cvAnalyzer: cvAnalyzerTranslations,
  jobAnalyzer: jobAnalyzerTranslations,
  fileUploadComponent: fileUploadComponentTranslations,
  companyResearch: companyResearchTranslations,
  versionHistory: versionHistoryTranslations,
  profile: profileTranslations,
  userProfile: userProfileTranslations,
  teamManagement: teamManagementTranslations,
  userManagement: userManagementTranslations,
  errors: errorsTranslations,
  errorMessages: errorMessagesTranslations,
  training: trainingTranslations,
  result: resultTranslations,
  validation: validationTranslations,
  reports: reportsTranslations
};

// Export as 'translations' for backward compatibility
export const translations = allTranslations;
